// ** Kameralar
const initialShos = {}

const shos = (state = initialShos, action) => {
  switch (action.type) {
    case "SET_SHOS_CONTENT":
      return { ...action.val }
    default:
      return state
  }
}

export default shos
